//アンカーリンクのスムーススクロール
$('a[href^="#"]').click(function(){
	let speed = 500;
	let href= $(this).attr("href");
	let target = $(href == "#" || href == "" ? 'html' : href);
	let position = target.offset().top;
	$("html, body").animate({scrollTop:position}, speed, "swing");
	return false;
});


// //TOPへ戻るボタン(スクロールしたら途中から表示され、footerで止まる)
// $(function() {
//   $(window).on('scroll', function() {
//     const scrollTop = $(this).scrollTop();

// 		if (scrollTop >= 100) {
// 			$("#js-pageTopWrap").addClass('is-show');
// 			$("#js-pageTopBtn").addClass('is-fixed');
//     } else {
// 			$("#js-pageTopWrap").removeClass('is-show');
// 			$("#js-pageTopBtn").removeClass('is-fixed');
//     }

//     const scrollHeight = $(document).height();
//     const scrollPosition = $(window).height() + scrollTop;
//     const footHeight = $(".footer_wrap").innerHeight(); //footerの高さ（＝止めたい位置）

//     if (scrollPosition >= scrollHeight - footHeight) {
//       $("#js-pageTopBtn").removeClass('is-fixed');
//     }
//   });

// });

//スクロールアニメーション用
if($('[data-scroll]').length){
	let _EffectH = 120;
	$(window).on('scroll load', function() {
		let _scTop = $(this).scrollTop();
		let _scBottom = _scTop + $(this).height();
		let _effectPos = _scBottom - _EffectH;
		$('[data-scroll]').each( function() {
			let _thisPos = $(this).offset().top;
			if ( _thisPos < _effectPos ) {
				$.when(
					$(this).addClass('is-show')
				).done(function() {
					$(this).delay(100).queue(function(){
						$(this).addClass('is-done')
					})
				});
			}
		});
	});
}
